<template>
  <Modal ref="modal" v-bind="{ redirectOnClose: true }">
    <div class="modal max-w-md mx-auto" slot-scope="{ closeModal }" @click.stop>
      <div class="modal__header">
        <h6 class="heading">
          {{ $t('addPage') | capitalize }}
        </h6>
      </div>
      <div class="modal__body space-y-4">
        <ValidationObserver slim v-slot="{ handleSubmit, invalid }" ref="observer">
          <form class="space-y-16" @submit.prevent="handleSubmit(submit)">
            <div class="space-y-8">
              <ValidationProvider
                name="title"
                vid="title"
                rules="required"
                v-slot="{ errors, failed }"
                slim
              >
                <BaseFormGroup class="w-full">
                  <BaseFormLabel for="title"> Title * </BaseFormLabel>
                  <BaseFormInput
                    id="title"
                    v-model="pageData.title"
                    :disabled="submitting"
                    :invalid="failed"
                    placeholder="enter title..."
                    v-select
                  />
                  <BaseFormInlineMessage v-if="failed" danger>
                    {{ errors[0] }}
                  </BaseFormInlineMessage>
                </BaseFormGroup>
              </ValidationProvider>

              <ValidationProvider
                name="url"
                vid="url"
                rules="required"
                v-slot="{ errors, failed }"
                slim
              >
                <BaseFormGroup>
                  <BaseFormLabel> Url * </BaseFormLabel>
                  <BaseFormInput v-model="pageData.url" type="url" :disabled="submitting" />
                  <BaseFormInlineMessage v-if="failed" danger>
                    {{ errors[0] }}
                  </BaseFormInlineMessage>
                </BaseFormGroup>
              </ValidationProvider>

              <ValidationProvider
                name="description"
                vid="description"
                v-slot="{ errors, failed }"
                slim
              >
                <BaseFormGroup>
                  <BaseFormLabel> Description </BaseFormLabel>
                  <BaseFormTextarea v-model="pageData.description" :disabled="submitting" />
                  <BaseFormInlineMessage v-if="failed" danger>
                    {{ errors[0] }}
                  </BaseFormInlineMessage>
                </BaseFormGroup>
              </ValidationProvider>
            </div>
            <div class="space-x-2 text-right">
              <BaseButton type="button" ghost :disabled="submitting" @click="closeModal">
                Cancel
              </BaseButton>
              <BaseButton primary :disabled="invalid || submitting"> Submit </BaseButton>
            </div>
          </form>
        </ValidationObserver>
      </div>
    </div>
  </Modal>
</template>

<script>
import Modal from '@/components/Ui/Modal.vue';
import { pageMethods, pageComputed } from '@/store/helper';

export default {
  name: 'ModalPageEdit',
  components: {
    Modal,
  },
  props: {
    pageId: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    submitting: false,
    pageData: {
      title: '',
      url: '',
      description: '',
    },
  }),
  computed: {
    ...pageComputed,
  },
  watch: {
    page: {
      handler({ title = null, url = null, description = null }) {
        this.pageData.title = title;
        this.pageData.url = url;
        this.pageData.description = description;
      },
      deep: true,
    },
  },
  created() {
    this.setCurrent(this.pageId);
    this.pageData.title = this.page.title;
    this.pageData.url = this.page.url;
    this.pageData.description = this.page.description;
  },
  methods: {
    ...pageMethods,
    submit() {
      const { pageId, pageData } = this;
      this.submitting = true;
      this.updatePage({ pageId, pageData })
        .then(() => {
          this.$refs.modal.closeModal();
        })
        .catch(() => {
          this.submitting = false;
        });
    },
  },
};
</script>
